export function getRuntimeConfig() {
    return portalConfig;
}
